export default __webpack_public_path__ + "static/media/Img_balance_of_materials.6d908de7.svg";